// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__THB7R","hasClickEvent":"Card_hasClickEvent__u77cB","actions":"Card_actions__-fvXm"};